import { GlobeIcon, LogoutIcon, ViewListIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ShowIf from "../show-if/ShowIf";
import { useTwilioChat } from "../../hooks/useTwilioChat";
import UserAvatarDropdown from "../avatar/UserAvatarDropdown";
import { useCallback, useEffect, useState } from "react";
import { Conversation } from "@twilio/conversations";
import NotificationMenu from "../notification";
import { ChatContextProvider } from "../../context/ChatContext";
import ChatMenuNavbar from "../chat_v2/ChatMenuNavbar";

type NavbarProps = {
  avatarUrl?: string;
  showChatIcon?: boolean;
  onChatClick?: () => void;
  showLanguageIcon?: boolean;
  onLanguageClick?: () => void;
  showLogoutIcon?: boolean;
  onLogout?: () => void;
  subscriptionAlert?: string;
  onClick?: () => void;
  showNotificationIcon: boolean;
};
export default function Navbar(props: NavbarProps) {
  const {
    avatarUrl,
    showChatIcon,
    showLanguageIcon,
    onLanguageClick,
    showLogoutIcon,
    onLogout,
    subscriptionAlert,
    onClick,
    showNotificationIcon,
  } = props;
  const Context = useAuth();


  const isMessagesPage = window.location.pathname.includes("messages");

  return (
    <ChatContextProvider>
      <div className="w-full h-fit flex flex-col gap-2">
        <div className="flex justify-between p-4  bg-white border-b border-gray-200 md:border-none md:shadow-md md:rounded-md">
          <div className="w-full flex items-center justify-start gap-4">
            <ViewListIcon
              onClick={onClick}
              className="w-6 h-6 lg:hidden cursor-pointer text-gray-700"
            />
            <UserAvatarDropdown
              email={Context?.currentUser?.account?.email}
              userName={Context?.currentUser?.name}
              profilePictureUrl={avatarUrl}
              className="w-8 h-8"
              alt="avatar"
            />
            <ShowIf condition={!!showChatIcon && !isMessagesPage}>
              <ChatMenuNavbar />
            </ShowIf>
            <ShowIf condition={!!showNotificationIcon}>
              <NotificationMenu />
            </ShowIf>
          </div>
          <ShowIf condition={!!subscriptionAlert?.trim()}>
            <div className="w-full flex justify-center">
              <SubscriptionAlert text={subscriptionAlert!} />
            </div>
          </ShowIf>
          <div className="w-full flex items-center justify-end gap-4">
            <ShowIf condition={!!showLanguageIcon}>
              <GlobeIcon
                className="w-6 h-6  flex text-gray-400 cursor-pointer"
                onClick={onLanguageClick}
              />
            </ShowIf>
            <ShowIf condition={!!showLogoutIcon}>
              <LogoutIcon
                className="w-6 h-6 rtl:rotate-180 text-gray-400 cursor-pointer"
                onClick={onLogout}
              />
            </ShowIf>
          </div>
        </div>
        <ShowIf condition={!!subscriptionAlert?.trim()}>
          <div className="mx-auto md:hidden">
            <SubscriptionAlert text={subscriptionAlert!} />
          </div>
        </ShowIf>
      </div>
    </ChatContextProvider>
  );
}

const SubscriptionAlert = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center w-fit border text-red-600 border-red-600 bg-red-100 py-[6px] px-4 rounded-md">
      <span className="text-sm font-medium">{text}</span>
    </div>
  );
};
